import VueBus from 'Common/Logical/VueBus.js';

export function reset() {
    if (!window.JSVars || process.env.NODE_ENV === 'testing') {
        window.JSVars = {}
    }

    if (!window.JSVars.callbacks || process.env.NODE_ENV === 'testing') {
        window.JSVars.callbacks = {}
    }

    if (!window.JSVars.VueBus || process.env.NODE_ENV === 'testing') {
        window.JSVars.VueBus = new VueBus();
    }

    if (!window.JSVars.__Vue__ || process.env.NODE_ENV === 'testing') {
        // Vue.config.performance = process.env.NODE_ENV !== 'production'
        // window.JSVars.__Vue__ = Vue
    }
}
